
import React from 'react';
import { EnhancedDashboardOverview } from './EnhancedDashboardOverview';

const DashboardOverview = () => {
  return <EnhancedDashboardOverview />;
};

export default DashboardOverview;
